export default {"src":"/_next/static/media/PRTG.f2c43488.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};